<template>
  <div class="pmd-home">
    <div class="pmd-top">
      <div class="top-font-top">Welcome</div>
      <div  class="top-font-bottom">To TOM</div>
      <img src="../assets/headPortrait.png" class="headPortrait">
    </div>
    <div class="pmd-platform">
      欢迎使用TOM平台
    </div>
    <div class="pmd-site" >
      <div v-for="item in webSitList" :key="item" class="pmd-site-content">
<!--        {{item.name}}：<a :href="item.url" target="_blank">{{item.url}}</a>-->
        {{item.name}}：<a :href="item.url" >{{item.url}}</a>
      </div>
    </div>
    <div class="pmd-travel">
      <div class="pmd-travel-top">选择感兴趣的网站</div>
      <div class="pmd-travel-bottom">开启你的兴趣知识之旅吧</div>
    </div>
    <img src="../assets/topArrows.png" class="arrows">
  </div>
</template>

<script>
export default {
  name: "PmdHome",
  data() {
    return {
      webSitList:[
        {
          name:"博客",
          url:"https://blog.tomtangmu.com"
        }
      ],
    }
  }
}
</script>

<style scoped>
.pmd-home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.pmd-top{
  width: 100vw;
  height: 35vh;
  background-image: url("../assets/lvdi.png");
  background-size:100% 100%;
  background-repeat:no-repeat;

  box-sizing: border-box;

}
.top-font-top{
  text-align: center;
  margin-top: 6vh;
  width: 100vw;
  height: 6vh;
  font-size: 40px;
  font-family: Apple-Chancery, Apple;
  font-weight: normal;
  color: #FFFFFF;
}
.top-font-bottom{
  text-align: center;
  margin-top: 1vh;
  width: 100vw;
  height: 6vh;
  font-size: 30px;
  font-family: Apple-Chancery, Apple;
  font-weight: normal;
  color: #FFFFFF;
}
.headPortrait{
  height: 16vh;
  width: 33vw;
}
.pmd-platform{
  margin-top: 2vh;
  width: 100vw;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.pmd-site{
  width: 100vw;
  height: 40vh;
  font-size: 16px;
  font-weight: 400;
  font-family: PingFangSC-Regular, PingFang SC;
}
.pmd-site-content{
  margin-top: 2vh;
  text-align: left;
  margin-left: 12vw;
}
.pmd-travel{
  margin-top: 0vh;
  width: 100vw;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;

}
.pmd-travel-top{
  letter-spacing: 2vw;
}
.pmd-travel-bottom{
  letter-spacing: 2vw;
}
.arrows{
  height: 16vh;
  width: 33vw;
  margin-left: 33vw;
}
</style>
